<template>
  <v-layout wrap :class="'dash' + config.dashClass + ''" style="">
    <Grid ref="grid"
      :draggable="true"
      :sortable="true"
      :cellWidth="200"
      :cellHeight="126"
      :items="data">
      <template slot="cell" slot-scope="props">
        <v-flex md2 fluid>
        <!--<div class="col-md-2">-->
          <div class="box box-widget widget-user" v-on:dblclick="ondblclick(props.item)">
            <div class="widget-user-headertext-center">
              <span class="widget-user-username center-text dashtitlereb ssoort"
                    v-if="(config.hasText && props.item.name)">{{props.item.name }}</span>
            </div>
            <div class="widget-user-image">
              <img class="img-md me-img-in-box"  v-bind:src="props.item.imageUrl" style=" -webkit-user-drag: none;;cursor: pointer"
                   onerror="" v-bind:alt="props.item.name">
            </div>
          </div>
        </v-flex>

      </template>
    </Grid>
    <!-- ;this.src='/static/svg/missingFile.svg' -->
  </v-layout>
</template>

<script>
import Vue from 'vue'
import Grid from 'vue-js-grid'

Vue.use(Grid)

export default {
  name: 'mySortableDash',
  props: {
    gridWidth: {
      type: Number,
      default: -1
    },
    cellWidth: {
      type: Number,
      default: 80
    },
    cellHeight: {
      type: Number,
      default: 80
    },
    draggable: {
      type: Boolean,
      default: false
    },
    dragDelay: {
      type: Number,
      default: 0
    },
    sortable: {
      type: Boolean,
      default: false
    },
    center: {
      type: Boolean,
      default: false
    },
    requestURI: {
      type: String,
      required: false,
      default: 'brand'
    },
    taskId: {
      type: String,
      required: true,
      default: ''
    },
    link: {
      type: String,
      required: false,
      default: 'brand'
    },
    msg: {
      type: String,
      required: false,
      default: 'brand'
    },
    host: {
      type: String,
      required: true,
      default: 'brand'
    },
    responseData: {
      type: Array,
      required: false,
      default: function () {
        return []
      }
    },
    data: {
      type: Array,
      required: true,
      default: function () {
        return []
      }
    },
    config: {
      type: Object,
      required: true,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {}
  },

  mounted () {
    this.$on('items', function (a, b, c) {
    })
  },
  methods: {
    onGetFile (data) {
      console.log('onGetFile', data)
    },
    ondblclick (data) {
      console.log('ondblclick', data)
      window.surfAndScan.download(data.id, this.onGetFile)
    },
    getData (self) {
      console.log('' + self.$refs.grid)
      var sorted = self.$refs.grid.list.slice().sort(function (a, b) {
        console.log(a)
        return a.sort * 1 - b.sort * 1
      })
      var result = {list: []}
      sorted.forEach(function (item) {
        result.list.push({
          orderString: item.sort + 100,
          guid: item.item.guid
        })
      })
      console.log(result)
      return result
    },
    makeRouterURL (vueModel) {
      if (this.config.hasURLMaker) {
        return this.$parent.$options.methods.makeRouterURL(this.$parent, vueModel)
      } else {
        return this.config.link + vueModel.guid
      }
    },
    downloadItem (item) {
      console.log('downloadItem', item)
      window.open(item.imageUrl, '_new')
    },
    makeImageURL (vueModel) {
      if (this.$parent.$options.methods.makeImageURL) {
        return this.$parent.$options.methods.makeImageURL(this.$parent, vueModel)
      }
      return this.host + '/mobile/images/' + vueModel.imageGuid + '/image'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h1, h2 {
    font-weight: normal;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #42b983;
  }
</style>



// WEBPACK FOOTER //
// src/components/list/vue-sortable-dash.vue